import { TestimonialColumns } from "./TestimonialColumns"
import { TestimonialRows } from "./TestimonialRows"
import { TestimonialSlider } from "./TestimonialSlider"

const renderStyle = {
  columns: TestimonialColumns,
  rows: TestimonialRows,
  slider: TestimonialSlider,
}

export const TestimonialList = ({ style, testimonials }) => {
  const Comp = renderStyle[style] || null
  return (
    testimonials &&
    testimonials.length > 0 &&
    Comp !== null && <Comp testimonials={testimonials} />
  )
}
